/**
 * Species-inspired plumage palettes for Perch the bird.
 * Each palette is a friendly, warm color combo.
 */

export interface BirdPalette {
  readonly id: string;
  readonly name: string;
  readonly head: string;
  readonly belly: string;
  readonly chest: string;
  readonly tuft: string;
  readonly cheek: string;
}

export const BIRD_PALETTES: Readonly<Record<string, BirdPalette>> = {
  robin: {
    id: 'robin',
    name: 'Robin',
    head: '#2A2018',
    belly: '#FF8A6E',
    chest: '#FF6B5B',
    tuft: '#FF8A6E',
    cheek: '#FFB4A3',
  },
  goldfinch: {
    id: 'goldfinch',
    name: 'Goldfinch',
    head: '#1F1A0F',
    belly: '#FFE08A',
    chest: '#FFC54D',
    tuft: '#FFC54D',
    cheek: '#FFD773',
  },
  bluebird: {
    id: 'bluebird',
    name: 'Bluebird',
    head: '#1A2540',
    belly: '#FFB386',
    chest: '#6DA8E0',
    tuft: '#6DA8E0',
    cheek: '#FFC7A8',
  },
  canary: {
    id: 'canary',
    name: 'Canary',
    head: '#3D3520',
    belly: '#FFF0B8',
    chest: '#FFD94A',
    tuft: '#FFD94A',
    cheek: '#FFE680',
  },
  mint: {
    id: 'mint',
    name: 'Warbler',
    head: '#1F2E20',
    belly: '#FFE8B8',
    chest: '#7FCF9F',
    tuft: '#FFB86E',
    cheek: '#A8DCBE',
  },
  berry: {
    id: 'berry',
    name: 'Bullfinch',
    head: '#2A1830',
    belly: '#FFC9C0',
    chest: '#D86B9E',
    tuft: '#D86B9E',
    cheek: '#F0A8C4',
  },
  blush: {
    id: 'blush',
    name: 'Rose Finch',
    head: '#3A1F2A',
    belly: '#FFDBE0',
    chest: '#F28AA3',
    tuft: '#F28AA3',
    cheek: '#FFB8C8',
  },
  sunset: {
    id: 'sunset',
    name: 'Sunset',
    head: '#2A1A1F',
    belly: '#FFD89E',
    chest: '#FF8558',
    tuft: '#FFB36B',
    cheek: '#FFCBA8',
  },
} as const;

export type PaletteId = keyof typeof BIRD_PALETTES;

export type Accessory = 'none' | 'beanie' | 'leaf' | 'bowtie' | 'glasses' | 'flower';
export const ACCESSORIES: readonly Accessory[] = [
  'none',
  'beanie',
  'leaf',
  'bowtie',
  'glasses',
  'flower',
];
